/* Hero slideshow — crossfade between slides, dependency free.
   Auto-advance is paused on hover, on focus within, when the tab is hidden and
   when the visitor prefers reduced motion. */
(function () {
  function setup(root) {
    if (root.__mdmHero) return;
    root.__mdmHero = true;

    var slides = root.querySelectorAll('[data-mdm-hero-slide]');
    if (slides.length < 2) return;

    var dots = root.querySelectorAll('[data-mdm-hero-dot]');
    var delay = parseInt(root.dataset.autoplay, 10) || 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer = null, paused = false;

    function show(n) {
      n = (n + slides.length) % slides.length;
      if (n === i) return;
      slides[i].classList.remove('is-active');
      slides[i].setAttribute('aria-hidden', 'true');
      slides[n].classList.add('is-active');
      slides[n].removeAttribute('aria-hidden');
      if (dots[i]) dots[i].removeAttribute('aria-selected');
      if (dots[n]) dots[n].setAttribute('aria-selected', 'true');
      i = n;
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!delay || reduce || paused) return;
      timer = setInterval(function () { show(i + 1); }, delay);
    }

    /* Deliberately no pause on hover — the hero keeps cycling with the pointer
       over it. Focus still pauses so a slide cannot change under someone who
       has tabbed onto one of its buttons. */
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function () { paused = false; start(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    var prev = root.querySelector('[data-mdm-hero-prev]');
    var next = root.querySelector('[data-mdm-hero-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.dataset.mdmHeroDot, 10)); start(); });
    });

    /* Swipe on touch, without blocking vertical scrolling. */
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { show(i + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    }, { passive: true });

    start();
  }

  function init() { document.querySelectorAll('[data-mdm-hero]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
